<!-- template for the modal component -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-left
      wrap>
      <factoring-detail-info
        :factoring-id="id"
        :factoring="factoring"
        :bank-claim="bankClaim"
        :claimant="claimant"
        :factoring-ext="factoringExtensions"/>
      <v-flex md12>
        <h3 class="heading-4">{{ 'krita.common.bankClaimInfo' | translate }}</h3>
        <br >
        <v-card>
          <BankClaimInfoDatagrid
            :bank-claim="bankClaim"
          />
        </v-card>
      </v-flex>
      <v-flex md12>
        <h3 class="heading-4">{{ 'krita.factoring.paymentstofactoring' | translate }}</h3>
        <br >
        <v-card>
          <search-text-field
            :search-phrase="paymentsSearch"
            :row-count="paymentsRowCount"
            @search="paymentsSearchRefresh"
          />
          <factoring-detail-payments-datagrid
            :loading-payments="loadingPayments"
            :payments="payments"
            :rows-per-page="paymentsRowsPerPage"
            @refreshWithSort="refreshPaymentsWithSort"
          />
          <div class="text-xs-center pt-2">
            <pagination
              :selected-page="paymentsSelectedPage"
              :rows-per-page="paymentsRowsPerPage"
              :row-count="paymentsRowCount"
              @changeDisplayedRowCount="paymentChangeDisplayedRowCount"
              @clickedPage="changePaymentsPage"/>
          </div>
        </v-card>
      </v-flex>
      <v-flex md12>
        <h3 class="heading-4">{{ 'krita.factoring.bufferallocation' | translate }}</h3>
        <br >
        <v-card>
          <FactoringDetailBufferDatagrid
            :buffers="buffers"
            :loading-buffer="loadingBuffer"
            :buffers-row-count="buffersRowCount"/>
          <div class="text-xs-center pt-2">
            <pagination
              :selected-page="buffersSelectedPage"
              :rows-per-page="buffersRowsPerPage"
              :row-count="buffersRowCount"
              @changeDisplayedRowCount="buffersChangeDisplayedRowCount"
              @clickedPage="changeBuffersPage"/>
          </div>
        </v-card>
      </v-flex>
      <v-flex md12>
        <h3 class="heading-4">{{ 'krita.factoring.transfersout' | translate }}</h3>
        <br >
        <v-card>
          <factoring-detail-transfers-datagrid
            :transfers="transfers"
            :rows-per-page="transfersRowsPerPage"
            :loading-transfers="loadingTransfers"/>
          <div class="text-xs-center pt-2">
            <pagination
              :selected-page="transfersSelectedPage"
              :rows-per-page="transfersRowsPerPage"
              :row-count="transfersRowCount"
              @changeDisplayedRowCount="transfersChangeDisplayedRowCount"
              @clickedPage="changeTransfersPage"/>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
import TwoStateButton from './controllers/TwoStateButton.vue';
import SearchTextField from './controllers/SearchTextField';
import Pagination from './controllers/Pagination.vue';
import FactoringDetailBufferDatagrid from './factoringDetail/FactoringDetailBufferDatagrid';
import FactoringDetailTransfersDatagrid from './factoringDetail/FactoringDetailTransfersDatagrid';
import FactoringDetailPaymentsDatagrid from './factoringDetail/FactoringDetalPaymentsDatagrid';
import FactoringDetailInfo from './factoringDetail/FactoringDetailInfo';
import BankClaimInfoDatagrid from './factoringDetail/BankClaimInfoDatagrid';
import EnumIterator from './helper/EnumIterator';
	export default {
	    components: {TwoStateButton, Pagination, FactoringDetailInfo, FactoringDetailBufferDatagrid, FactoringDetailTransfersDatagrid,FactoringDetailPaymentsDatagrid, SearchTextField, BankClaimInfoDatagrid},
      // eslint-disable-next-line vue/require-prop-types
        props: ['id'],
		data: () => ({
          paymentsPagination: {},
          payments: [],
          loadingPayments: false,
          paymentsSort: {},
          paymentsSelectedPage: 1,
          paymentsRowsPerPage: 5,
          paymentsRowCount: '',
          paymentsSearch: '',


          bufferPagination: {},
          buffers: [],
          loadingBuffer: false,
          buffersSort: {},
          buffersSelectedPage: 1,
          buffersRowsPerPage: 5,
          buffersRowCount: '',

          transfersPagination: {},
          transfers: [],
          loadingTransfers: false,
          transfersSort: {},
          transfersSelectedPage: 1,
          transfersRowsPerPage: 5,
          transfersRowCount: '',

          bankClaim: {},
          claimant: {},
          debtor: {},
          factoring: {},
          factoringExtensions: {
            duration: '',
            bufferAmount: '',
            unpaidCapital: '',
            unpaidFee: '',
          },
		}),
    watch:{
      $route() {
        this.refreshPage();
      }
    },
      mounted ()
      {
        let self = this;

        self.refreshPage();
      },
        methods: {
	      changePaymentsPage (page)
          {
            let self = this;

            self.paymentsSelectedPage = page;
            self.refreshPaymentsData();
          },
          changeBuffersPage (page)
          {
            let self = this;

            self.buffersSelectedPage = page;
            self.refreshBufferAlocationData();
          },
          changeTransfersPage (page)
          {
            let self = this;

            self.transfersSelectedPage = page;
          },
          paymentChangeDisplayedRowCount (rowCount)
          {
            let self = this;

            self.paymentsSelectedPage = 1;
            self.paymentsRowsPerPage = isNaN(parseInt(rowCount))? -1 : parseInt(rowCount);
            self.refreshPaymentsData();
          },
          buffersChangeDisplayedRowCount (rowCount)
          {
            let self = this;

            self.buffersSelectedPage = 1;
            self.buffersRowsPerPage = isNaN(parseInt(rowCount))? -1 : parseInt(rowCount);
            self.refreshBufferAlocationData();
          },
          transfersChangeDisplayedRowCount (rowCount)
          {
            let self = this;

            console.log(rowCount);
          },
          refreshFactoringDetailData ()
          {
            let self = this;

            let factoringDetailFetch = self.$store.dispatch('factorings/getFactoringDetail', {id: self.id, });
            factoringDetailFetch.then(response =>
            {
              self.processFactoringDetail(response);
              self.processTransfers(response);
            })
          },

          refreshPaymentsWithSort (pagination)
          {
            let self = this;

            self.paymentsSort = {};
            self.paymentsSort[pagination.sortBy] = pagination.descending ? 'desc' : 'asc';
            self.refreshPaymentsData ();
          },
          paymentsSearchRefresh (search)
          {
            let self = this;

            if (search !=='')
            {
              self.paymentsSelectedPage = 1;
            }
            self.paymentsSearch = search;
            self.refreshPaymentsData();
          },
          refreshPaymentsData ()
          {
            let self = this;

            self.loadingPayments = true;
            let paymentsFetch = self.$store.dispatch('factorings/getPaymentsForFactoringDetail', {id: self.id, page: self.paymentsSelectedPage, rowsPerPage: self.paymentsRowsPerPage, sort: self.paymentsSort });
            paymentsFetch.then(response =>
            {
              self.processPayments(response);
              self.loadingPayments = false;
            })
          },
          refreshBufferAlocationData ()
          {
            let self = this;

            self.loadingBuffer = true;
            let paymentsFetch = self.$store.dispatch('factorings/getBufferAllocationsForFactoringDetail', {id: self.id, page: self.buffersSelectedPage, rowsPerPage: self.buffersRowsPerPage, sort: self.buffersSort });
            paymentsFetch.then(response =>
            {
              self.processBuffers(response);
              self.loadingBuffer = false;
            })
          },
          processFactoringDetail (obj)
          {
            let self = this;

            self.bankClaim = obj.BankClaim;
            self.claimant = obj.Claimant;
            self.debtor = obj.Debtor;
            self.factoring = obj.Factoring;
            self.factoringExtensions = {
              duration: obj.Duration,
              bufferAmount: obj.BufferAmount,
              unpaidCapital: obj.UnpaidCapital,
              unpaidFee: obj.UnpaidFee
            }
          },
          processPayments (obj)
          {
            let self = this;

            let payments = obj.Rows;
            self.payments = [];
            for (let payment of payments)
            {
              let paymentClient = {
                Capital: payment.Capital,
                Created: payment.Created,
                Date: payment.Date,
                DebtorRegistryId: payment.DebtorRegistryId,
                FeeAmount: payment.FeeAmount,
                Id: payment.Id,
                IsProcessing: payment.IsProcessing,
                PaymentSource: payment.PaymentSource,
                PenaltyInterestAmount: payment.PenaltyInterestAmount,
                RefactoringId: payment.RefactoringId,
                RepaymentId: payment.RepaymentId,
                SettlingId: payment.SettlingId,
                TransactionId: payment.TransactionId
              };
              self.payments.push(paymentClient);
            }
            self.paymentsRowCount = obj.TotalRowCount;
          },
          processTransfers (obj)
          {
            let self = this;

            let transfers = obj.TransfersFromFactoring;
            self.transfers = [];
            for (let transfer of transfers)
            {
              let transferClient = {
                Account: transfer.Account,
                Amount: transfer.Amount,
                AuthorizedBy: transfer.AuthorizedBy,
                BatchTransferId: transfer.BatchTransferId,
                ClaimantId: transfer.ClaimantId,
                Created: transfer.Created,
                Id: transfer.Id,
                Status: transfer.Status,
                LastError: transfer.LastError,
                Modified: transfer.Modified,
                ObjectId: transfer.ObjectId,
                ObjectType: transfer.ObjectType,
                Reference: transfer.Reference,
                TransferTrigger: self.$t(EnumIterator.processTransferTrigger(transfer.TransferTrigger)),
                TransferedDate: transfer.TransferedDate,
                TriggerPaymentId: transfer.TriggerPaymentId
              };
              self.transfers.push(transferClient);
            }
            self.transfersRowCount = transfers.length;
          },
          processBuffers (obj)
          {
            let self = this;

            let buffers = obj.Rows;
            self.buffers = [];
            for (let buffer of buffers)
            {
              let bufferClient = {
                Capital: buffer.Capital,
                Created: buffer.Created,
                Date: buffer.Date,
                DebtorRegistryId: buffer.DebtorRegistryId,
                FeeAmount: buffer.FeeAmount,
                Id: buffer.Id,
                IsProcessing: buffer.IsProcessing,
                PaymentSource: self.$t(EnumIterator.processPaymentSource(buffer.PaymentSource)),
                PenaltyInterestAmount: buffer.PenaltyInterestAmount,
                RefactoringId: buffer.RefactoringId,
                RebufferId: buffer.RebufferId,
                SettlingId: buffer.SettlingId,
                TransactionId: buffer.TransactionId,
                FactoringId: buffer.FactoringId
              };
              self.buffers.push(bufferClient);
            }
            self.buffersRowCount = obj.TotalRowCount;
          },
          refreshPage ()
          {
            let self = this;

            self.refreshPaymentsData();
            self.refreshFactoringDetailData();
            self.refreshBufferAlocationData();
          }
        },
	}
</script>

<style lang="css" scoped>
.btn {
  width:100px;
  max-width:100px;
}
.pseudolink {
  color:blue;
  cursor:pointer;
}

span .v-icon{
  color: #2f5194;
}


</style>
